<template>
  <div class="chat-panel">
    <div class="chat-box-list">
      <Search
        class="search-box"
        v-if="false"
        @showChat="showSearchChat"
      ></Search>
      <div class="group-box">
        <ul class="user-list">
          <li v-for="(chat, index) in chatList" :key="index" class="user">
            <a
              :class="currentChat && currentChat.id === chat.id ? 'active' : ''"
              href="javascript:"
              @click="showChat(chat)"
            >
              <i class="counts" v-if="chat.unReadCount > 0">{{
                chat.unReadCount
              }}</i>
              <img
                :src="chat.avatar"
                style="border-radius:50%"
                alt="头像"
                v-if="chat.avatar"
              />
              <Icon
                type="ios-contact"
                style="position: absolute;top: 0.4rem;left: 2rem;"
                v-else
                size="40"
              />
              <b>{{ chat.name }}</b>
              <p
                :class="[
                  'user-status',
                  `${
                    onLineUserList[chat.id] === '1'
                      ? 'status-active'
                      : 'status-leave'
                  }`,
                ]"
              >
                {{ onLineUserList[chat.id] === "1" ? "在线" : "离线" }}
              </p>
            </a>
            <Icon type="md-close" @click="delChat(chat)"></Icon>
          </li>
        </ul>
      </div>
    </div>
    <div class="chat-box">
      <Top></Top>
      <UserChat :chat="currentChat" @showChat="showChat"></UserChat>
    </div>
  </div>
</template>
<script>
import Search from "../components/search.vue";
import Top from "../components/top.vue";
import UserChat from "../components/chat.vue";
import {
  ChatListUtils,
  imageLoad,
  MessageTargetType,
} from "../../../utils/ChatUtils";
import RequestUtils from "../../../utils/RequestUtils";

import conf from "../conf";

export default {
  components: {
    Search,
    Top,
    UserChat,
  },
  data() {
    return {
      chatList: [],
      onLineUserList: {},
      timer: null,
    };
  },
  watch: {
    "$store.state.chatList": {
      deep: true,
      immediate: true,
      handler: function(val) {
        this.chatList = val;
        if (this.timer === null) {
          this.timer = setInterval(async () => {
            const promises = val.map(async (cur) => {
              const online = await this.getUserIsOnline(cur.id);
              return { id: cur.id, online: "" + online };
            });
            const results = await Promise.all(promises);
            const res = results.reduce((acc, cur) => {
              acc[cur.id] = cur.online;
              return acc;
            }, {});
            this.onLineUserList = res;
          }, 5000);
          val.reduce(async (acc, cur) => {
            const online = await this.getUserIsOnline(cur.id);
            acc[cur.id] = "" + online;
            return acc;
          }, this.onLineUserList);
        }
        if (this.chatList.length === 0) {
          this.$store.commit("setCurrentChat", {});
        } 
        const totalUnRead = val.reduce((acc, cur) => {
          return acc + cur.unReadCount;
        }, 0);
        window.parent.postMessage(
          {
            type: "unRead",
            content: totalUnRead,
          },
          "*"
        );
      },
    },
  },
  computed: {
    currentChat: {
      get: function() {
        return this.$store.state.currentChat;
      },
      set: function(currentChat) {
        this.$store.commit(
          "setCurrentChat",
          JSON.parse(JSON.stringify(currentChat))
        );
      },
    },
  },
  methods: {
    getUserIsOnline(userId) {
      if (!userId) {
        return false;
      }
      let formData = new FormData();
      formData.append("userId", userId);
      return RequestUtils.request(conf.getUserIsOnline(), formData);
    },
    findCommonObjects(array1, array2) {
      const commonObjects = [];
      for (let obj1 of array1) {
        for (let obj2 of array2) {
          if (obj1.name === obj2.name) {
            commonObjects.push(obj1);
            break; // 如果找到相同名称的对象，跳出内部循环
          }
        }
      }
      return commonObjects;
    },
    showChat: function(chat) {
      let self = this;
      self.$store.commit("resetUnRead");
      if(chat.id !== self.currentChat.id) {
        self.currentChat = chat;
      }
      // 每次滚动到最底部
      self.$nextTick(() => {
        imageLoad("message-box");
      });
    },
    showSearchChat: function(chat) {
      let self = this;
      self.$store.commit("resetUnRead");
      self.currentChat = chat;
      // 每次滚动到最底部
      self.$nextTick(() => {
        imageLoad("message-box");
      });
      ChatListUtils.resetChatList(
        self,
        chat,
        conf.getHostUrl(),
        MessageTargetType.FRIEND
      );
    },
    delChat(chat) {
      this.$store.commit("delChat", chat);
      this.$store.commit("setCurrentChat", {});
    },
  },
  activated: function() {},
  mounted: function() {
    // window.addEventListener("pageshow", () => {
    //   let self = this;
    //   // 当前聊天室
    //   if (self.$route.query.chat) {
    //     self.$store.commit(
    //       "setCurrentChat",
    //       JSON.parse(JSON.stringify(self.$route.query.chat))
    //     );
    //   }
    //   // 重新设置chatList
    //   self.$store.commit(
    //     "setChatList",
    //     ChatListUtils.getChatList(self.$store.state.user.id)
    //   );
    //   // 每次滚动到最底部
    //   self.$nextTick(() => {
    //     imageLoad("message-box");
    //   });
    // })
  },
};
</script>
<style lang="scss" scoped>
@import "@/static/styles/theme";

.ivu-tabs-content {
  height: 100%;
}

.chat-panel {
  width: 26rem;
  background-color: $color-write;
  height: 100%;
  display: flex;
  flex-direction: row;

  .chat-box {
    flex: 1;
    background-color: #f1f0f0;
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .chat-box-list {
    height: 100%;
    width: 22rem;
    display: flex;
    flex-direction: column;

    .search-box {
      margin: 1.5rem;
      width: 19rem;
    }
  }
}

.group-box {
  height: 100%;
  overflow-y: auto;
  padding-left: 5px;
  padding-right: 5px;
  border-right: 1px solid #efefef;

  .count {
    color: #aaaaaa;
  }

  li {
    list-style: none;
    position: relative;
    font-size: 1.2rem;
    cursor: pointer;
    font-weight: 200;
    margin-bottom: 2rem;

    h5 {
      padding: 0.5rem 0;
      cursor: pointer;
      font-size: 1.3rem;
      font-weight: 200;

      i {
        vertical-align: baseline;
      }
    }

    img {
      width: 4.4rem;
      height: 4.4rem;
      position: absolute;
      top: 0.4rem;
      left: 2rem;
    }

    b {
      position: absolute;
      font-size: 1.3rem;
      left: 7.5rem;
      overflow: hidden;
      text-overflow: ellipsis;
      font-weight: 600;
      top: 0.6rem;
    }

    p.user-status {
      position: absolute;
      left: 7.5rem;
      bottom: 0.4rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 75%;
      font-size: 1.1rem;

      &.status-leave {
        color: #e76a6a;
      }
      &.status-active {
        color: #1fbee1;
      }
    }
  }

  .user {
    height: 5.2rem;
    position: relative;

    a {
      display: block;
      width: 100%;
      height: 100%;
      color: $color-default;
      position: relative;

      .counts {
        display: inline-block;
        width: 1.8rem;
        height: 1.6rem;
        background-color: #f36464;
        border-radius: 50%;
        color: $color-write;
        text-align: center;
        font-style: normal;
        position: absolute;
        right: 1rem;
        top: 0.5rem;
        z-index: 99999999999;
      }

      p {
        width: 12rem;
      }
    }

    &:hover {
      background-color: #efefef !important;

      & > i {
        color: $color-default;
        background-color: $color-write;
      }
    }

    .active {
      background-color: #efefef !important;
    }

    & > i {
      position: absolute;
      right: 1rem;
      bottom: 1.6rem;
      cursor: pointer;
      border-radius: 50%;
      padding: 0.2rem;
      text-align: center;
      color: $color-light-gray;

      &:hover {
        color: $color-default;
        background-color: $color-write;
      }
    }
  }
}
</style>
